// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2j4qy","log":"ModalInventoryLogs_log__3eEb4","date":"ModalInventoryLogs_date__3gqKE","userName":"ModalInventoryLogs_userName__3HPXD"};